export const thumbSize = 16;
export const colorBarHeight = thumbSize - 2;
export const halfThumbSize = thumbSize / 2;
export const sliderHeight = 28;
